import { Stack } from "@altimateai/lego";
import { SidebarMenuItem, Skeleton } from "@altimateai/lego";

const ChatRowSkeleton = () => {
  return (
    <SidebarMenuItem className="al-px-2" aria-label="Loading chat session">
      <Stack direction="column" className="al-h-auto al-py-3" gap="xs">
        <Stack>
          <Skeleton className="al-w-4 al-h-4 al-rounded-full" />
          <Skeleton className="al-h-4 al-w-[70%]" />
        </Stack>
        <Stack direction="row" align="center" gap="xs">
          <Skeleton className="al-h-3 al-w-20" />
        </Stack>
      </Stack>
    </SidebarMenuItem>
  );
};

export default ChatRowSkeleton;
